import DepartmentSelect from "@/components/DepartmentSelect";
import Field from "@/components/Field";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import ProjectRoleSelect from "../ProjectRoleSelect";
import { writeProjectLimitPeriod } from "@/schemas/projectLimit";
import { isRequired } from "@/lib/form";
import { useFormContext } from "react-hook-form";

interface ProjectRoleOrDepartmentFieldProps {
  isRoleDependent: boolean;
  projectId?: string;
}

export const ProjectRoleOrDepartmentField = ({
  isRoleDependent,
  projectId,
}: ProjectRoleOrDepartmentFieldProps) => {
  const { t } = useTranslation();
  const form = useFormContext();

  const fieldProps = {
    name: "entityId",
    label: t(
      isRoleDependent
        ? "projectLimits.periodsDialog.role"
        : "projectLimits.periodsDialog.department",
    ),
    required: isRequired(writeProjectLimitPeriod.shape.entityId),
  };

  if (isRoleDependent && !projectId) {
    return (
      <Field
        {...fieldProps}
        render={({ field }) => (
          <Input
            disabled
            placeholder={t("projectLimits.periodsDialog.noProjectId")}
            {...field}
          />
        )}
      />
    );
  }

  if (isRoleDependent && projectId) {
    return (
      <Field
        {...fieldProps}
        render={({ field }) => (
          <ProjectRoleSelect
            projectId={projectId}
            className="w-full"
            inDialog
            {...field}
            onChange={(value, selectedItem) => {
              field.onChange(value);
              if (selectedItem?.name) {
                form.setValue("entityName", selectedItem.name);
              } else {
                form.setValue("entityName", "");
              }
            }}
          />
        )}
      />
    );
  }

  return (
    <Field
      {...fieldProps}
      render={({ field }) => (
        <DepartmentSelect
          className="w-full"
          inDialog
          {...field}
          onChange={(value, selectedItem) => {
            field.onChange(value);
            if (selectedItem?.name) {
              form.setValue("entityName", selectedItem.name);
            } else {
              form.setValue("entityName", "");
            }
          }}
        />
      )}
    />
  );
};
